/**
 * Nombres de acción que atiende la Function `account`, no `management-command`.
 *
 * Se separaron el 5 sept 2026 (ver `functions.md` de `rs-functions`): `account`
 * concentra lo que un usuario hace sobre su propia cuenta o contenido;
 * `management-command` queda para acciones de equipo/staff. `command-gateway.ts`
 * usa esta lista para decidir a qué Function mandar cada acción sin que cada
 * gateway de la app tenga que saberlo — si un caso nuevo aparece acá pero no
 * en `rs-functions/functions/account/src/actions/index.py`, la Function
 * responde `unknown_action` y hay que revisar esta lista.
 */
export const ACCOUNT_ACTIONS: ReadonlySet<string> = new Set([
  'activate_playground_scene',
  'add_activity_collaborator',
  'add_playground_app',
  'add_playground_collaborator',
  'archive_playground',
  'broadcast_notification',
  'cancel_activity',
  'cancel_activity_registration',
  'check_username',
  'clear_user_presence',
  'clone_playground',
  'complete_activity',
  'count_notifications',
  'count_unread_direct_conversations',
  'count_unread_notifications',
  'create_activity',
  'create_activity_occurrence',
  'create_app',
  'create_board',
  'create_board_category',
  'create_bug_report',
  'create_contact',
  'create_mcp_token',
  'create_playground',
  'create_playground_scene',
  'create_playground_shortcut',
  'create_post',
  'create_rsgame_project',
  'create_user',
  'delete_activity',
  'delete_all_notifications',
  'delete_board',
  'delete_board_category',
  'delete_inactive_rsgame_instances',
  'delete_notification',
  'delete_playground',
  'delete_playground_scene',
  'delete_playground_shortcut',
  'delete_post',
  'delete_rsgame_project',
  'delete_rsgame_version',
  'deprecate_app',
  'draft_app',
  'find_profile_by_username',
  'follow_user',
  'get_activity_feedback',
  'get_activity_identity',
  'get_app',
  'get_board',
  'get_managed_activity',
  'get_managed_post',
  'get_own_bug_report',
  'get_playground',
  'get_playground_audio_url',
  'get_playground_playlist',
  'get_playground_runtime',
  'get_public_activity',
  'get_public_post',
  'get_public_profile',
  'get_rsgame_dashboard',
  'get_rsgame_management',
  'get_rsgame_project',
  'get_session_profile',
  'get_shared_playground_runtime',
  'get_user_profile',
  'list_apps',
  'list_board_posts',
  'list_boards',
  'list_bug_reports',
  'list_contacts',
  'list_direct_conversations',
  'list_direct_messages',
  'list_followers',
  'list_following',
  'list_managed_activities',
  'list_managed_boards',
  'list_managed_posts',
  'list_mcp_tokens',
  'list_my_activity_registrations',
  'list_notification_broadcasts',
  'list_notifications',
  'list_playground_collaborators',
  'list_playground_media',
  'list_playground_scenes',
  'list_playgrounds',
  'list_post_categories',
  'list_public_activities',
  'list_public_posts',
  'list_rsgame_projects',
  'mark_all_notifications_read',
  'mark_contact_responded',
  'mark_notification',
  'move_post_to_draft',
  'notify_occurrence_needs_closing',
  'open_direct_conversation',
  'publish_activity',
  'publish_app',
  'publish_post',
  'publish_rsgame_version',
  'register_for_activity_occurrence',
  'remove_activity_collaborator',
  'remove_playground_app',
  'remove_playground_collaborator',
  'reorder_playground_apps',
  'reorder_playground_shortcuts',
  'report_activity_absence',
  'report_client_error',
  'reset_password',
  'resolve_account',
  'resolve_bug_report',
  'restore_playground',
  'review_activity_registration',
  'revoke_mcp_token',
  'search_users',
  'seed_apps',
  'send_activity_reminder',
  'send_direct_message',
  'send_notification',
  'set_activity_attendance',
  'set_activity_occurrence_status',
  'set_board_status',
  'set_notification_preferences',
  'set_playground_app_data',
  'set_playground_media_sources',
  'set_playground_sharing',
  'set_profile_display_name',
  'set_profile_username',
  'set_user_permissions',
  'submit_activity_feedback',
  'touch_user_presence',
  'unfollow_user',
  'unlist_post',
  'update_activity',
  'update_activity_collaborator',
  'update_activity_occurrence',
  'update_app',
  'update_board',
  'update_board_category',
  'update_playground',
  'update_playground_app',
  'update_playground_collaborator',
  'update_playground_scene',
  'update_playground_shortcut',
  'update_post',
  'update_rsgame_project',
]);
